export enum SsoType {
  PEP = 'pep',
  TCMService = 'tcmanservice',
  CMS = 'cmspep',
  TCMANHEALTHINEERS = 'tcmanhealthineers',
}
